import React, { useState } from "react";
import SectionTitle from "../../components/SectionTitle";
import ServiceCard from "../../components/ServiceCard";
import { BsCodeSlash } from "react-icons/bs";
import { FiDatabase } from "react-icons/fi";
import { GiPalette } from "react-icons/gi";
import { MdAddchart } from "react-icons/md";
import { CgDatabase } from "react-icons/cg";
import { SiServerless } from "react-icons/si";
import WithHelmet from "../../utils/WithHelmet";
import { Link } from "react-router-dom";

// meta tags
const pageTitle = "Servies | Md Shahar Shitol";
const description =
  "Explore a collection of impressive services provided by Md Shahar Shitol. From web applications to innovative solutions, our services and expertise in full-stack web development.";
const keywords = [
  "service",
  "services",
  "design",
  "redesign",
  "backend development",
  "api integration",
  "web applications",
  "full-stack web development",
  "showcase",
  "md shahar shitol",
  "frontend developer",
  "hire me",
  "fortuino",
  "recruiting hire",
  "bongodev",
];
// demo data
const serviceEnd = {
  frontend: [
    {
      title: `Design to Code`,
      desc: `I can translate your provided design into code that the idea will convert into an actual web application.`,
      icon: BsCodeSlash,
    },
    {
      title: `Website Redesign`,
      desc: `I can help you to revamp your old website. It will be modernized, optimized and use new features and technologies.`,
      icon: GiPalette,
    },
    {
      title: `API Integration`,
      desc: `I will integrate any API into your application using the most efficient asynchronous way following all the best practices.`,
      icon: MdAddchart,
    },
  ],
  backend: [
    {
      title: "Back End Server",
      desc: "Our developed back end servers are efficient, robust, and well optimized. Highly scalable servers are well secured too.",
      icon: CgDatabase,
    },
    {
      title: "Database Design",
      desc: "I prefer to use latest document databases. I design the database following the best data structure based on the application.",
      icon: FiDatabase,
    },
    {
      title: "Serverless System",
      desc: "Serverless Systems are free from server-related hassles where applications still get better service with real-time database.",
      icon: SiServerless,
    },
  ],
};

const Services = () => {
  const [selectedButton, setSelectedButton] = useState("frontend");
  function handleButtonClick(data) {
    setSelectedButton(data);
  }
  //
  const filteredservices =
    selectedButton === "frontend"
      ? serviceEnd.frontend
      : selectedButton === "backend"
      ? serviceEnd.backend
      : [];

  return (
    <section
      className="md:p-10 p-3 py-10 mb-16  mx-auto"
      data-aos="fade-right"
      data-aos-offset="200"
      data-aos-delay="50"
      data-aos-duration="700"
      data-aos-easing="ease-in-out"
    >
      <SectionTitle>Services</SectionTitle>
      <h1 className="text-3xl text-neutral font-bold capitalize">
        Build the real thing
      </h1>
      <div className="flex justify-center mt-8">
        <button
          onClick={() => handleButtonClick("frontend")}
          className={` mx-3 transition-all ${
            selectedButton === "frontend" ? "text-accent" : "text-neutral/30"
          }`}
        >
          Frontend
        </button>
        <button
          onClick={() => handleButtonClick("backend")}
          className={`mx-3 transition-all ${
            selectedButton === "backend" ? "text-accent" : "text-neutral/30"
          }`}
        >
          Backend
        </button>
      </div>
      {/* cards grid */}
      <div className="grid grid-cols-1 service-card-grid gap-3 lg:gap-8 mt-10 p-2 justify-items-center">
        {filteredservices?.map((service, id) => (
          <ServiceCard service={service} key={id} />
        ))}
      </div>
      <div className="flex flex-col justify-center items-center gap-6">
        <h1 className="text-3xl text-center text-neutral font-bold capitalize mt-10">
          Message me to 4x your business
        </h1>
        <Link
          to="/contact"
          // type="submit"
          // value="Send Message"
          className="btn mx-auto rounded-none border-none bg-accent text-primary hover:bg-accent/90"
        >
          Send Message
        </Link>
      </div>
    </section>
  );
};

export default WithHelmet(Services, pageTitle, description, keywords);
